import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { WorkflowRoutes } from '@/modules/to/workflow/constants/workflow.constants';

export const router = PageRouteConfig.factory(
  {
    path: `/${WorkflowRoutes.WORKFLOW_EXECUTION}/:entityItemId`,
    name: WorkflowRoutes.WORKFLOW_EXECUTION,
    component: () =>
      import(/* webpackChunkName: "workflow-execution-page" */ './pages/WorkflowExecutionPage.vue'),
    props: true,
  },
  Module.WORKFLOW
);
